import React from 'react';
import { useTranslation } from 'react-i18next';
import { ResponsiveContainer } from 'recharts';

import {
  Card, Col, Row,
} from 'antd';

import withAuth from '@common/hocs/withAuth';
import MainLayout from '@common/layouts/MainLayout';

import BusinessType from './containers/BusinessType/BusinessType';
import MapForVehicles from './containers/MapForVehicle';
import DeviceListTable from './containers/DeviceListTable/DeviceListTable';

import useHome from './useHome';
import styles from './Home.module.less';

function Home() {

  useHome();

  return (
    <MainLayout applyWidthLimit>
      <ResponsiveContainer>
        <div className={styles.wrapper}>
          <div className={styles.fields_wrapper} />
          <Row gutter={[16, 8]}>
            <Col
              xs={{
                span: 24,
              }}
              sm={{
                span: 24,
              }}
              md={{
                span: 12,
              }}
              lg={{
                span: 12,
              }}
              xl={{
                span: 12,
              }}
            >
              <div style={{
                background: '#fff', padding: 25, minHeight: '270px', height: 'fit-content',
              }}
              >
                <BusinessType />
              </div>
            </Col>

            <Col
              xs={{
                span: 24,
              }}
              sm={{
                span: 24,
              }}
              md={{
                span: 12,
              }}
              lg={{
                span: 12,
              }}
              xl={{
                span: 12,
              }}
            >
              <div style={{
                background: '#fff', padding: 25, minHeight: '270px', height: 'fit-content',
              }}
              >
                <MapForVehicles />
              </div>
            </Col>
          </Row>

          <Row gutter={[16, 8]}>
            <DeviceListTable className={styles.tables} />
          </Row>
        </div>
      </ResponsiveContainer>
    </MainLayout>
  );

}

export default withAuth(Home);
